export default __webpack_public_path__ + "1a906d07cb1b70af412aa81b80c107c9.png";